/** Pure helpers for the account menu, kept out of the component so they can be unit-tested. */

/** The user's initials, from their name; "A" when there is no name to show. */
export function accountInitials(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return 'A';
  if (words.length === 1) return (words[0] ?? '').slice(0, 2).toUpperCase();
  const first = words[0]?.[0] ?? '';
  const last = words[words.length - 1]?.[0] ?? '';
  return `${first}${last}`.toUpperCase();
}

/** A role as a person reads it: "owner" is "Owner", "ar_lead" is "Ar lead". */
export function roleName(role: string | undefined): string {
  return role ? role.replaceAll('_', ' ').replace(/^\w/, letter => letter.toUpperCase()) : '';
}

/** The role and company line under the user's name, e.g. "Owner · AIprise". */
export function accountLabel(role: string | undefined, company: string | null | undefined): string {
  const roleText = roleName(role);
  const companyText = (company ?? '').trim() || 'Alder';
  return [roleText, companyText].filter(Boolean).join(' · ');
}
